var _rect, _circle, _circle2, _rect2, _circle3, _circle4, _circle5, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHematologia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 280,
    viewBox: "0 0 480 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 280,
    rx: 24,
    fill: "#FFF1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 70,
    r: 38,
    fill: "#FECDD3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 216,
    r: 46,
    fill: "#FFE4E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 46,
    width: 248,
    height: 184,
    rx: 20,
    fill: "white",
    stroke: "#FDA4AF",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 110,
    r: 26,
    fill: "#FB7185"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 140,
    r: 34,
    fill: "#F43F5E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 106,
    r: 22,
    fill: "#FB7185"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 182,
    width: 180,
    height: 16,
    rx: 8,
    fill: "#FFE4E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 64,
    width: 148,
    height: 14,
    rx: 7,
    fill: "#FECDD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHematologia);
export default __webpack_public_path__ + "static/media/hematologia.6bd4fd24983c7396d04b68bded7ac074.svg";
export { ForwardRef as ReactComponent };